export default "__VITE_ASSET__CCyMB3Z9__"